import { Horizontal, Vertical } from "gls"
import { routesType } from "router/routes"
import ConfigNavigation from "./ConfigNavigation"
import { Navigate } from "react-router-dom"
import RenderRouteComponent from "router/RenderRouteComponent"
import { media, style } from "typestyle"
import { colours } from "styling/colours"
import { TABLETDEVICEWIDTH } from "config/constants"
import Navigation from "./Navigation"
import { observer } from "mobx-react"
import HeaderDefault from "components/Header/HeaderDefault"
import { useContext, useEffect } from "react"
import { useLayoutStore, useRootStore } from "contexts/RootStore.context"
import { initialPendo } from 'pendo';
import useDevice from "hooks/useDevice"
import { Helmet } from "react-helmet-async";
import { isString } from "lodash"

import 'react-sliding-pane/dist/react-sliding-pane.css';
import { NotificationContext, NotificationsValue } from "contexts/notification.context"

type LayoutProps = {
  route: routesType
}

export var NOTIFICATION: NotificationsValue;

export const Layout = observer(({ route }: LayoutProps) => {

  const { webConfig, userInfo } = useRootStore()
  const { isTabletDevice } = useDevice()
  const { setPageTitle, pageTitle, reset } = useLayoutStore()
  NOTIFICATION = useContext(NotificationContext)


  useEffect(() => {
    if (webConfig.run_pendo) {
      initialPendo(userInfo.username, userInfo.email, userInfo.name);
      console.log('Pendo is running.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    reset()
    setPageTitle(route.title)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route.title, route.url])

  const nav = !route.hideNavigation
    ? route.isConfig
      ? <ConfigNavigation navCollapsedDefault={route.navCollapsedDefault} />
      : <Navigation navCollapsedDefault={route.navCollapsedDefault} />
    : <></>

  const content = route.redirectTo
    ? <Navigate to={route.redirectTo} />
    : route.component && <RenderRouteComponent component={route.component} />

  return (
    <>
      <Helmet>
        <title>{`ILS Portal${isString(pageTitle) && pageTitle !== "" ? ` - ${pageTitle}` : ''}`}</title>
      </Helmet>
      <Horizontal sizing="stretch" height="100%" spacing={0}>
        {nav}
        <Vertical spacing={0} sizing="stretch" className={pageStyle(isTabletDevice)}>
          {!route.excludeHeader && <HeaderDefault />}
          {content}
        </Vertical>
      </Horizontal>
    </>
  )
})

const pageStyle = (isTabletDevice: boolean) => style(
  {
    background: colours.background,
    marginLeft: isTabletDevice ? "auto" : "25px",
    padding: isTabletDevice ? "20px" : "35px 30px 10px 0px",
    height: '100%',
    overflow: "hidden",
  },
  media({ maxWidth: TABLETDEVICEWIDTH }, { padding: [25, 20] })
);
